import React, { Component } from 'react';
import { ChromePicker } from 'react-color'
import $ from 'jquery';
import Select from 'react-select';
import Slider from 'rc-slider';
import { saveAs } from 'file-saver';
import Dropzone from 'react-dropzone';
import 'rc-slider/assets/index.css';
import uuid from 'uuid';

import CustomIconCreator from './CustomIconCreator';
import PropertyEditor from './PropertyEditor';

import { createMedia, fetchMedia } from '../actions/actions_media';
import { changeControl, changeMapData, changeMapCategories } from '../actions/index';

const typeImages = {
  'Polygon' : `data:image/svg+xml;base64,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`,
  'LineString' : `data:image/svg+xml;base64,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`,
}

function niceBackgroundColor(hex, alpha = '0.4'){
  var c;
  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length== 3){
          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return `rgba(${[(c>>16)&255, (c>>8)&255, c&255].join(',')}, ${alpha})`;
  }
}

class GeometryEdit extends Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.toggleCustomCreator = this.toggleCustomCreator.bind(this)
    this.state = {
      displayColorPicker: false,
      displayCustomIconCreator: false,
      displayPropertyEditor : false,
      currentEditorTab: 'defaults',
      displayIconColorPicker : false,
      iconSize : 100,
      mediaPage : 1,
      iconAnchor : 'bottom',
      icons : {
        defaults : [], maki : [], mapkey: []
      },
      displayDirectionsPopup: false,
      categoryInput: ''
    }
  }

  componentDidMount() {
    // Calls to get icon text file lists
    let textFiles = ['defaults','maki','mapkey'];
    var that = this;
    textFiles.forEach(function(textFile) {
      fetch($('#wp_mapbox_gl_js_plugin_url').val()+'/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/'+textFile+'/'+textFile+'-icons.txt',{
        method: 'GET'
      })
      .then(response => response.text())
      .then(text => {
        var newState = JSON.parse(JSON.stringify(that.state));
        var imageArray = text.split("\n");
        newState['icons'][textFile] = imageArray;
        that.setState(newState);
      })
      .catch(error => console.log(error.message));
    })
    this.props.dispatch(fetchMedia(this.state.mediaPage));
  }

  componentWillReceiveProps(nextProps) {
    // console.log('nextProps', nextProps);
  }

  fetchMoreMedia() {
    this.props.dispatch(fetchMedia(this.state.mediaPage+1));
    this.setState({mediaPage:this.state.mediaPage+1});
  }

  closeIconCreator() {
    this.setState({displayCustomIconCreator:false});
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose(e) {
    e.preventDefault();
    this.setState({ displayColorPicker: false, displayIconColorPicker: false })
  }

  toggleCustomCreator(e) {
    if(e) { e.preventDefault(); }
    this.setState({displayCustomIconCreator:!this.state.displayCustomIconCreator})
  }

  selectCategory(e) {
    const newMapData = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
    newMapData.forEach(function(feature) {
      if(feature.id===this.props.currentGeometry.id) {
        feature.properties.category = e.target.value;
      }
    }.bind(this));
    this.props.dispatch(changeMapData(newMapData));
  }

  handleMake3D = (e, currentFeature) => {
    e.preventDefault();

    const currentFeatureCopy = JSON.parse(JSON.stringify(currentFeature));
    const newMapData = [].concat(this.props.mapObject.mapData);
    const newFeatureColor = currentFeatureCopy.properties.color ? currentFeatureCopy.properties.color : '#333';
    const newFeature = {
      id: uuid(),
      type: 'Feature',
      properties: {
        name: currentFeatureCopy.properties.name,
        description: currentFeatureCopy.properties.description,
        marker_title: currentFeatureCopy.properties.marker_title,
        popup_open: currentFeatureCopy.properties.popup_open,
        category : currentFeatureCopy.properties.category,
        color: newFeatureColor,
        marker_icon_url: 'http://localhost:8888/mapbox-plugin/wp-content/plugins/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/black_default.png',
        marker_icon_anchor: 'bottom',
      },
      geometry: {
        type: 'Polygon',
        coordinates: currentFeatureCopy.geometry.coordinates
      },
      prevId: currentFeatureCopy.id
    };

    if (typeof currentFeatureCopy.properties.base_height === 'undefined' || typeof currentFeatureCopy.properties.height === 'undefined') {
      // make it 3d
      newFeature.fillType = 'extrusion'
      newFeature.properties.height = 200000;
      newFeature.properties.base_height = 0;
    } else {
      // make it 2d
      newFeature.fillType = 'fill'
    }

    const mbDrawFeatureCollection = this.props.addToMbDrawHelper(newFeature);
    this.props.Draw.add(mbDrawFeatureCollection);
    newMapData.push(newFeature);
    this.props.dispatch(changeMapData(newMapData));
    // that.props.dispatch(selectGeometry(newFeatureId.id)) => Geometry selected in Map.js via feature.prevId
  }

  handleDirectionsClick = (e) => {
    e.preventDefault();

    if (this.state.displayDirectionsPopup) {
      // hide modal
      this.setState({ displayDirectionsPopup: false });
    } else {
      // show modal
      this.setState({ displayDirectionsPopup: true });
    }
  }

  handleChromePickerColor = (currentGeometryProperties) => {
    // return RGBA -> hexA conversion
  }

  exportGeoJson = (e) => {
    e.preventDefault();

    const featureCollection = {
      'type': 'FeatureCollection',
      'features': this.props.mapObject.mapData
    }

    const mapName = $('#title').val() ? $('#title').val() : 'wp-gl-js-mapmaker';
    const file = `${mapName}.geojson`;

    saveAs(new File([JSON.stringify(featureCollection)], file, {
      type: "text/plain;charset=utf-8"
    }), file);
  }

  addDirectionsToPopup(featureID, e) {
    var newMapData = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
    newMapData.forEach(function(feature) {
      if(featureID===feature.id) {
        const lngLat = feature.geometry.coordinates;
        if(e.target.checked) {
          feature.properties.description = feature.properties.description + '<br /><br /><button class="button" data-lng-lat="'+lngLat +'" data-feature-id="'+featureID+'" id="wp_mapbox_gl_js_set_directions">Directions</button>';
        } else {
          feature.properties.description = feature.properties.description.replace('<br /><br /><button class="button" data-lng-lat="'+lngLat +'" data-feature-id="'+featureID+'" id="wp_mapbox_gl_js_set_directions">Directions</button>','');
        }
      }
    })
    this.props.dispatch(changeMapData(newMapData));
    this.props.dispatch(changeControl(true,'directions'));
  }

  render() {

    const popover = {
      position: 'absolute',
      zIndex: 10000,
      marginTop: '-250px'
    }

    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

    var markerOptions = [{
        value : 'defaults/black_default.png',
        label : 'Black Default',
        url : 'defaults/black_default.png'
    }];
    markerOptions.push({value:'custom-creator',label:'Make your own marker',url: ''})

    let counts = { 'Point': 0, 'Polygon': 0, 'LineString': 0 };
    let properType = `${this.props.type.charAt(0).toUpperCase()}${this.props.type.substr(1)}`;
    return (
      <div id="wp-mapbox-gl-js-geometry-options" className="wp-mapbox-gl-js-geometry-options">
        {this.props.type==='marker'&&this.state.displayCustomIconCreator ?
          <CustomIconCreator currentGeometry={this.props.currentGeometry} closeIconCreator={this.closeIconCreator.bind(this)} {...this.props} />
        : false }
        {this.state.displayPropertyEditor ?
          <PropertyEditor currentGeometry={this.props.currentGeometry} closePropertyEditor={() => this.setState({displayPropertyEditor:false})} {...this.props} />
        : false}
        <div className="wp-mapbox-gl-js-edit-geometry-options">
          <div>
            <div className="wp-mapbox-gl-js-autcomplete-input-wrapper">
              {this.props.type==='marker' && <label>Add Marker by Address</label> }
              <div style={this.props.type==='marker' ? {display:'block'} : {display:'none'}} id="wp-mapbox-gl-js-autocomplete" className="autocomplete" />
            </div>

            {this.props.type==='upload' ?
              <div>
                <button className="button" style={{marginTop:'10px',float:'right'}} onClick={(e) => this.exportGeoJson(e)}>Export Current Map Features</button>
                <p>You can upload a file here and have it populate fills, lines, and points automatically.</p>
                <div className="wp-mapbox-gl-js-dropzone">
                  <Dropzone
                    onDrop={this.props.onDrop}
                    accept=".json, .csv, .kml, .geojson" >
                    <p>Drag and drop a geojson, kml, or csv file.</p>
                  </Dropzone>
                </div>
              </div>
            : false }

            {this.props.currentGeometry ?
              <div>
                <h3 className="wp-mapbox-gl-js-header">Edit {properType}s</h3>
                <div>
                  {this.props.type==='marker' ?
                    <div style={{display:'flex'}}>
                      <input type="text" className="widefat" style={{maxWidth:'100px'}} onChange={(e) => { this.props.setMapObject('marker_title',e.target.value) }} value={this.props.currentGeometry.properties.marker_title} />
                      {this.props.mapObject.controls.categoryFilter ?
                        <select value={this.props.currentGeometry.properties.category} onChange={this.selectCategory.bind(this)} style={{ marginLeft:'5px'}}>
                          <option value="">(no category)</option>
                          {this.props.mapObject.mapCategories.map((category) => {
                            return (
                              <option key={uuid()} value={category}>
                                {category}
                              </option>
                            );
                          })}
                        </select>
                      : null}
                    </div>
                  :
                    <div style={{display:'flex'}}>
                      <button className="button" onClick={ this.handleClick }>{this.state.displayColorPicker ? 'Close Color Picker' : 'Pick Color'}</button>
                      { this.state.displayColorPicker ? <div style={ popover }>
                        <div style={ cover } onClick={ this.handleClose }/>
                        <ChromePicker color={ this.props.currentGeometry.properties.rgb } onChange={(e) => { this.props.setMapObject('color',e) }} />
                      </div> : null }
                      {this.props.type === 'fill' ?
                        this.props.currentGeometry.fillType === 'extrusion' ?
                          <button style={{marginBottom:'5px'}} data-featureid={this.props.currentGeometry.id} className="button" id="make-2d" onClick={(e) => this.handleMake3D(e, this.props.currentGeometry)}>
                          Make 2D
                          </button>
                          :
                          <button style={{marginBottom:'5px'}} data-featureid={this.props.currentGeometry.id} className="button" id="make-3d" onClick={(e) => this.handleMake3D(e, this.props.currentGeometry)}>
                          Make 3D
                          </button>
                        : null
                      }
                      <button style={{marginBottom:'5px'}} data-featureid={this.props.currentGeometry.id} className="button" id="deleteFeature">Delete</button>
                      <button style={{marginBottom:'5px'}} onClick={(e) => { e.preventDefault(); this.setState({displayPropertyEditor:true}); }} className="button">Properties</button>
                      <input type="text" className="widefat" style={{maxHeight: '28px', maxWidth:'100px',marginLeft:'10px'}} onChange={(e) => { this.props.setMapObject('marker_title',e.target.value) }} value={this.props.currentGeometry.properties.marker_title} />
                      {this.props.mapObject.controls.categoryFilter ?
                        <select value={this.props.currentGeometry.properties.category} onChange={this.selectCategory.bind(this)} style={{ marginLeft:'5px'}}>
                          <option>(no category)</option>
                          {this.props.mapObject.mapCategories.map((category) => {
                            return (
                              <option key={uuid()} value={category}>
                                {category}
                              </option>
                              )
                          })}
                        </select>
                      : null}
                    </div>
                }
                </div>
                {this.props.type==='marker' ?
                  <div style={{marginTop:'10px'}}>
                    <button className="button" onClick={ this.toggleCustomCreator }>{this.state.displayCustomIconCreator ? 'Close Custom Editor' : 'Edit Marker Icon'}</button>
                    <button style={{marginBottom:'5px'}} data-featureid={this.props.currentGeometry.id} className="button" id="changePopupContent">Edit Marker Popup</button>
                    <button style={{marginBottom:'5px'}} onClick={(e) => { e.preventDefault(); this.setState({displayPropertyEditor:true}); }} className="button">Properties</button>
                    <button style={{marginBottom:'5px'}} data-featureid={this.props.currentGeometry.id} className="button" id="deleteFeature">Delete</button>
                    <div style={{marginTop:'5px',marginLeft:'5px',display:'inline-block'}}>
                      <input type="checkbox" onChange={(e) => { this.props.setMapObject('popup_open',e.target.checked) }} checked={this.props.currentGeometry.properties.popup_open} /> Popup open on load
                      <input type="checkbox"
                        onChange={this.addDirectionsToPopup.bind(this, this.props.currentGeometry.id)}
                        style={{ marginLeft: '5px' }}
                        checked={this.props.currentGeometry.properties.description && this.props.currentGeometry.properties.description.indexOf('<br /><br /><button class="button" data-lng-lat="'+this.props.currentGeometry.geometry.coordinates +'" data-feature-id="'+this.props.currentGeometry.id+'" id="wp_mapbox_gl_js_set_directions">Directions</button>')>-1}
                      />
                        Directions button in popup
                    </div>
                    <div>
                    </div>
                    {this.state.displayDirectionsPopup ?
                      <div>
                        <label>
                          Place directions button in popup
                          <input style={{ marginLeft: '5px' }} data-featureid={this.props.currentGeometry.id} type="checkbox" id="addDirectionsDestinationFromPopup" />
                        </label>
                      </div>
                      : null
                    }
                  </div>
                : false }
              </div>
            : false }
          </div>
          <div id="controls-container">
            {this.props.currentGeometry.fillType === 'extrusion' ?
              <div id="extrusion-input-container">
                <label>
                  Base Height
                  <input type="number" min="0" className="widefat" onChange={(e) => { this.props.setMapObject('base_height',e.target.value) }} value={this.props.currentGeometry.properties.base_height} />
                  <small>(height in metres)</small>
                </label>
                <label>
                  Height
                  <input type="number" min="0" className="widefat" onChange={(e) => { this.props.setMapObject('extrusion_height',e.target.value) }} value={this.props.currentGeometry.properties.height} />
                  <small>(height in metres)</small>
                </label>
                <p>To see more easily, tilt and rotate the map by right-clicking and dragging.</p>
              </div>
              : null
            }
          </div>
          {this.props.type!=='upload' ?
            <div>
              <hr
                style={{
                  borderWidth: '1px 0 0 0',
                  borderColor: '#F1F1F1',
                }}
                 />
              <div>
                <h5 className="wp-mapbox-gl-js-header">Current {properType}s</h5>
                <div className="wp_mapbox_gl_js_marker-tiles">
                {this.props.mapObject.mapData.map((feature, i) => {
                        // console.log(feature);
                  var type = 'Point';
                  if(this.props.type==='fill') {
                    type = 'Polygon';
                  }
                  if(this.props.type==='line') {
                    type = 'LineString';
                  }

                  counts[feature.geometry.type]++;

                  if (feature.geometry.type === type) {
                    return <div
                            onClick={() => this.props.dispatch(this.props.selectGeometry(feature.id))}
                            key={"marker-" + i}
                            style={{
                              backgroundColor: (type !== 'Point') && (
                                feature.id === this.props.mapActions.selectGeometry
                                  ? niceBackgroundColor(feature.properties.color)
                                  : niceBackgroundColor(feature.properties.color, '0.1')),
                              borderColor: (type !== 'Point') && feature.properties.color,
                              color: (type !== 'Point') && feature.properties.color,
                            }}
                            className={"wp_mapbox_gl_js_marker-tile " + (feature.id === this.props.mapActions.selectGeometry ? "selected" : "")}
                            >
    										{['Marker','Fill','Line'].indexOf(feature.properties.marker_title)>-1 ?
                          <div>{feature.properties.marker_title} {counts[feature.geometry.type]}</div>
                        : <div>{feature.properties.marker_title}</div> }

                        {type === 'Point' && <img
                          src={feature.properties.marker_icon_url.split('-wp_mapbox_gl_js_sizing-')[0]}
                          alt="Marker Image"
                        /> }
                        {type !== 'Point' && <img
                          src={typeImages[type]}
                          alt="Marker Image"
                        /> }
    									</div>;
    							}
                  return false;
                })}
                </div>
              </div>
            </div>
          : false }
        </div>
      </div>
      )
  }
}


// changeIconColor(e) {
//   console.log(e);
//   var canvas = document.getElementById('wp_mapbox_gl_js_canvas');
//   var ctx = canvas.getContext('2d');
//   var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
//   var imageData = ctx.getImageData(0, 0, img.width, img.height);
//
//   var colorCounting = {};
//   for (var i=0;i<imageData.data.length;i+=4) {
//     var thisColor = imageData.data[i]+','+imageData.data[i+1]+','+imageData.data[i+2];
//     if(!colorCounting[thisColor]) {
//       colorCounting[thisColor] = 1;
//     } else {
//       colorCounting[thisColor] = colorCounting[thisColor]+1;
//     }
//   }
//   console.log(colorCounting);
//   var commonestColor = [0,0]
//   for(var thisColor in colorCounting) {
//     if(colorCounting[thisColor]>commonestColor[1]) {
//       commonestColor = [thisColor,colorCounting[thisColor]]
//     }
//   }
//   console.log(commonestColor);
//   for (var i=0;i<imageData.data.length;i+=4) {
//     var thisColor = imageData.data[i]+','+imageData.data[i+1]+','+imageData.data[i+2];
//     if(commonestColor.indexOf(thisColor)>-1) {
//       imageData.data[i] = e.rgb.r;
//       imageData.data[i+1] = e.rgb.g;
//       imageData.data[i+2] = e.rgb.b;
//     }
//   }
//   // put the altered data back on the canvas
//   // ctx.drawImage(imageData, 0, 0, img.width, img.height);
//   console.log(imageData);
//   // ctx.clearRect(0, 0, canvas.width, canvas.height);
//   ctx.putImageData(imageData,0,0);
// }
// <button className="button" onClick={(e) => { e.preventDefault(); this.setState({displayIconColorPicker:!this.state.displayIconColorPicker}) }}>
//   {!this.state.displayIconColorPicker ? 'Open Color Selector' : 'Close Color Selector' }
// </button>
// { this.state.displayIconColorPicker ?
//   <div style={ popover2 }>
//     <div style={ cover } onClick={ this.handleClose }/>
//     <ChromePicker color={ this.props.currentGeometry.properties.color } onChange={this.changeIconColor.bind(this)} />
//   </div>
// : false }

export default GeometryEdit;



// WEBPACK FOOTER //
// ./src/components/GeometryEdit.js